// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ddd7ee9726373494b290","655":"9c3ad8e43296e4c2a6b7"}[chunkId] + ".js";
};